import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, change, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import { renderAutoCompleteMultipleSelection, renderAutoCompleteSingleSelect, renderCheckBox } from '../../../../components/reduxFields';
import Loader from '../../../../img/loader.gif';
import history from '../../../../history';
import { getMasterData } from '../../actions/index';

const styles = {
  font: {
    fontStyle: 'ITALIC',
  },
};

class ClientDetailsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,      
      iframeURL: '',
      isLoading: false,
      random: 0,
      isShowInactiveClientOnly: false,
      isShowActiveAndInactiveClients : false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
    this.checkReportSearch = this.checkReportSearch.bind(this);
  }

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({
      [input.name]: value,
    });
  }

  appointmentFilterByDate = (formData) => {
    this.resetIframe();
    let REPORT_URL  = GetReportUrl(this.props.agencyName);  
    let reportName = base64Encode('CL_ClientDetailsReport');
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "LocationId","Value": "`+ (formData.location || 0) + `"},{"Name": "TagIds","Value": "`+ (formData.tagIds && formData.tagIds.length > 0 ? formData.tagIds : 0) + `"},{"Name": "IsShowInactiveClientOnly","Value": "` + this.state.isShowInactiveClientOnly + `"},{"Name": "IsShowActiveAndInactiveClients","Value": "` + this.state.isShowActiveAndInactiveClients + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"},{"Name": "ViewTeamClientsOnlyPermissionForReports","Value": "` + this.props.viewTeamClientsOnlyPermission + `"},{"Name": "LoginUserId","Value": "` + this.props.loginUserID + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false});
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  
  checkReportSearch = (e, name) => {
    if (name === 'isShowInactiveClientOnly' && e.target.checked) {
      this.setState({isShowInactiveClientOnly : true, isShowActiveAndInactiveClients : false},()=>{
        this.props.dispatch(change('ClientDetailsReportForm', 'isShowActiveAndInactiveClients', false));
      });
    } else if (name === 'isShowInactiveClientOnly' && !e.target.checked) {
      this.setState({isShowInactiveClientOnly : false, isShowActiveAndInactiveClients : false},()=>{
        this.props.dispatch(change('ClientDetailsReportForm', 'isShowActiveAndInactiveClients', false));
      });
    } else if (name === 'isShowActiveAndInactiveClients' && e.target.checked) {
      this.setState({isShowActiveAndInactiveClients : true, isShowInactiveClientOnly : false },()=>{
        this.props.dispatch(change('ClientDetailsReportForm', 'isShowInactiveClientOnly', false));
      });
    } else if (name === 'isShowActiveAndInactiveClients' && !e.target.checked) {
      this.setState({isShowActiveAndInactiveClients : false, isShowInactiveClientOnly : false},()=>{
        this.props.dispatch(change('ClientDetailsReportForm', 'isShowInactiveClientOnly', false));
      });
    } 
    
  }
  componentWillMount() {      
    let masterData = { 'masterdata': 'MASTERTAGSFORALL' };
    this.props.getMasterData(masterData);   
  }
  handleNewChange = (input, selectedRecord) => {
    input.onChange(selectedRecord);
  }
  renderReport() {
    return (
      <Iframe url={this.state.iframeURL}
        // width="450px"
        height="580px"
        id="myId"
        className="manual_report"
        display="initial"
        position="relative"
        onLoad={(e)=> this.onLoadReport(e)}
        key={this.state.random}
        allowFullScreen />
    );
  }

  handleChange = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/staff-and-client-management-reports');
  }
  render() {
    const { handleSubmit } = this.props;
    //   let iframeUrl = `${REPORT_URL}?%2fHC.SqlReports%2fClientDetailsReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.state.organizationID + '&LocationID=' + this.state.locationID;
    // let windowsHeight = window.innerHeight + 159 + "px";
    // console.log(windowsHeight);
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Staff And Client Management {' > '} Client Detail Report</h2>
        :
          <h2 className="page_title">Client Detail Report</h2>
        }
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <div className="clearfix"></div>
            <div className="panel_title">
              <h7 style={styles.font}>*By default This report shows only active clients, please use filters for other options.</h7>   
            </div>
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-4 mt-35">
                  <Field name="location"
                    label="Location"
                    handleNewRequest={this.handleChange}
                    options={this.props.userLocationList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>    
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="tagIds"
                    label="Tags"
                    handleNewRequest={this.handleNewChange}
                    options={this.props.masterTagsForAll}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
                <div className="col-sm-4 mt-30">
                    <Field
                      className="mt20 mb0"
                      name="isShowInactiveClientOnly"
                      label="Show Inactive Clients Only"
                      onChange={(e) => this.checkReportSearch(e, 'isShowInactiveClientOnly')}
                      component={renderCheckBox}
                    />
                </div>
                <div className="col-sm-4 mt-30">
                    <Field
                      className="mt20 mb0"
                      name="isShowActiveAndInactiveClients"
                      label="Show Active And Inactive Clients"
                      onChange={(e) => this.checkReportSearch(e, 'isShowActiveAndInactiveClients')}
                      component={renderCheckBox}
                    />
                </div>            
                <div className="col-sm-7 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        {this.renderReport()}
      </div>
    );
  }
}

ClientDetailsReport = reduxForm({
  form: 'ClientDetailsReportForm',
})(ClientDetailsReport);

function mapStateToProps(state) {
  let locationArr = [];
  if (state.login.userLocationList) {
    locationArr = (state.login.userLocationList).map((obj) => {
      return (
        {
          id: obj.id,
          value: obj.locationName,
        }
      );
    });
  }

    
 // Start For Role Permission

 let userScreenPermission = [];
 if (state.login.userPermission) {
   let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
   userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
 }

 let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
 let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission && userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0] ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0].permission : false;


 // End For Role Permission

  return {
    orgID: state.login.loginUserInfo.organizationID,
    userLocationList: locationArr,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
    loginUserID: (state.login.loginUserInfo && state.login.loginUserInfo.userID) || null,
    masterTagsForAll: state.report.master_data.masterTagsforAll || [],
  };
}
export default connect(mapStateToProps, {getMasterData})(ClientDetailsReport);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/StaffAndClientManagementReports/ClientDetailsReport.js